module.exports = __webpack_public_path__ + "img/rocket-bg.efc6dfa2.svg";